import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "shelf-page" }
const _hoisted_2 = {
  key: 0,
  class: "shelf-state"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("加载中...")
const _hoisted_4 = {
  key: 1,
  class: "shelf-state shelf-state--error"
}
const _hoisted_5 = { class: "shelf-state-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "shelf-state-desc" }, "请检查链接后重试", -1)
const _hoisted_7 = { class: "shelf-main" }
const _hoisted_8 = {
  key: 0,
  class: "shelf-covers"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 查看作品 ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "shelf-token-arrow" }, "›", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "shelf-overview" }
const _hoisted_16 = { class: "shelf-name" }
const _hoisted_17 = { class: "shelf-price-row" }
const _hoisted_18 = { class: "shelf-price" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "shelf-price-symbol" }, "¥", -1)
const _hoisted_20 = { class: "shelf-price-value" }
const _hoisted_21 = {
  key: 0,
  class: "shelf-price-suffix"
}
const _hoisted_22 = { class: "shelf-stats" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "shelf-description"
}
const _hoisted_25 = {
  key: 1,
  class: "shelf-section"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", { class: "shelf-section-title" }, "委托信息", -1)
const _hoisted_27 = { class: "shelf-card shelf-delivery" }
const _hoisted_28 = {
  key: 0,
  class: "shelf-detail-row"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "交付时间", -1)
const _hoisted_30 = {
  key: 1,
  class: "shelf-detail-row"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "授权范围", -1)
const _hoisted_32 = {
  key: 2,
  class: "shelf-detail-row"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "发布权限", -1)
const _hoisted_34 = {
  key: 3,
  class: "shelf-detail-row"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "交付格式", -1)
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<section class=\"shelf-section\"><h2 class=\"shelf-section-title\">购前须知</h2><div class=\"shelf-card shelf-notice\"><div class=\"shelf-notice-title\">出现纠纷可联系平台客服</div><img class=\"shelf-notice-image\" src=\"https://cdn.qiandaoapp.com/interior/images/b3d77f69b048481898cb7c2d32c694d1.png!mfit_w750_h750_jpg\" alt=\"购前须知\"></div></section>", 1)
const _hoisted_37 = { class: "shelf-action" }
const _hoisted_38 = { class: "shelf-action-info" }
const _hoisted_39 = { class: "shelf-action-price" }
const _hoisted_40 = {
  key: 0,
  class: "shelf-action-stock"
}

import { computed, onMounted, provide, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import {
  Loading as VanLoading,
  NavBar as VanNavBar,
  Sticky as VanSticky,
  showImagePreview,
} from "vant";
import dayjs from "dayjs";
import DownloadBanner from "@/components/DownloadBanner/index.vue";
import MainButton from "@/components/MainButton/index.vue";
import CommentList from "@/components/CommentList/index.vue";
import ShelfApi from "@/apis/shelf";
import NftApi from "@/apis";
import { invokeAppByYYB } from "@/utils/mob";
import { useUsersStore } from "@/store/user";

interface ShelfAttachment {
  url: string;
  relatedId?: string;
  relatedType?: string;
}

interface ShelfCommission {
  commissionCompleteBefore?: string | number;
  isCompleteStartFromAccept?: boolean;
  scopeOfAuthorization?: string;
  publishPermission?: string;
  deliveryFormat?: string;
}

interface ShelfPrice {
  value?: string | number;
  valueV2?: string;
  suffix?: string;
}

interface ShelfStatus {
  isOnShelf?: boolean;
  isSoldOut?: boolean;
}

interface ShelfSimpleInfo {
  name?: string;
  description?: string;
  attachments?: ShelfAttachment[];
  images?: ShelfAttachment[];
  price?: ShelfPrice;
  sellTime?: string | number;
  status?: ShelfStatus;
}

interface ShelfProduct {
  stock?: string | number;
  disable?: boolean;
  isSoldOut?: boolean;
}

interface ShelfPspu {
  products?: ShelfProduct[];
}

interface ShelfDetailInfo {
  sellerId?: string;
  sellTime?: string | number;
  commission?: ShelfCommission;
  pspus?: ShelfPspu[];
  showAvailableInventory?: boolean;
  stats?: {
    soldAmount?: string | number;
    favoriteCount?: string | number;
  };
  status?: ShelfStatus;
}

interface ConfigItem {
  id: string;
  name: string;
}

type PublishConfig = Record<string, ConfigItem[]>;

interface ApiResponse<T> {
  code?: string | number;
  message?: string;
  data?: T;
}

interface PublishConfigResponse {
  data?: {
    publishConfig?: PublishConfig;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const usersStore = useUsersStore();
const { userInfo, getIsLogin } = storeToRefs(usersStore);

const shelfId = ref("");
const tradeType = ref("SHELF");
const tokenId = ref("");
const loading = ref(true);
const errorMessage = ref("");
const simpleInfo = ref<ShelfSimpleInfo>({});
const detailInfo = ref<ShelfDetailInfo>({});
const publishConfig = ref<PublishConfig>({});

provide("tradeId", shelfId);
provide("tradeType", tradeType);
provide("tokenId", tokenId);

const attachments = computed<ShelfAttachment[]>(() => {
  const list = simpleInfo.value?.attachments?.length
    ? simpleInfo.value.attachments
    : simpleInfo.value?.images || [];
  return list.filter((item: ShelfAttachment) => item?.url);
});

const commission = computed<ShelfCommission>(
  () => detailInfo.value?.commission || {}
);
const displayPrice = computed(() => {
  const price = simpleInfo.value?.price || {};
  return price.valueV2 || price.value || 0;
});

const priceSuffix = computed(() => simpleInfo.value?.price?.suffix || "");

const products = computed<ShelfProduct[]>(() =>
  (detailInfo.value?.pspus || []).flatMap((item) => item.products || [])
);

const totalStock = computed(() =>
  products.value.reduce((sum, item) => sum + Number(item.stock || 0), 0)
);

const isOwner = computed(
  () =>
    Boolean(getIsLogin.value) &&
    String(detailInfo.value?.sellerId || "") ===
      String(userInfo.value?.userId || "")
);

const isFutureSelling = computed(() => {
  const sellTime = Number(
    simpleInfo.value?.sellTime || detailInfo.value?.sellTime || 0
  );
  return sellTime > Date.now();
});

const isSoldOut = computed(() => {
  if (detailInfo.value?.status?.isSoldOut) return true;
  return (
    products.value.length > 0 &&
    products.value.every(
      (item) => item.isSoldOut || item.disable || Number(item.stock || 0) <= 0
    )
  );
});

const isOffShelf = computed(
  () =>
    simpleInfo.value?.status?.isOnShelf === false ||
    detailInfo.value?.status?.isOnShelf === false
);

const actionDisabled = computed(
  () =>
    !isOwner.value &&
    (isFutureSelling.value || isSoldOut.value || isOffShelf.value)
);

const actionText = computed(() => {
  if (isOwner.value) return "请去App操作";
  if (isFutureSelling.value) return "未开售";
  return "购买";
});

const deadlineText = computed(() => {
  const value = Number(commission.value.commissionCompleteBefore || 0);
  if (!value) return "";
  if (commission.value.isCompleteStartFromAccept) {
    const days = Math.max(1, Math.round(value / 86400000));
    return `接单后 ${days} 天`;
  }
  return dayjs(value).format("YYYY-MM-DD");
});

const hasDeliveryInfo = computed(() =>
  Boolean(
    deadlineText.value ||
      commission.value.scopeOfAuthorization ||
      commission.value.publishPermission ||
      commission.value.deliveryFormat
  )
);

const appendImageStyle = (url: string) => {
  if (!url || url.includes("!")) return url;
  return `${url}!mfit_w750_h750_jpg`;
};

const previewImage = (index: number) => {
  showImagePreview({
    images: attachments.value.map((item) => item.url),
    startPosition: index,
  });
};

const toTokenPage = (relatedId: string) => {
  const query: Record<string, string> = { tokenId: relatedId };
  if (typeof route.query._env === "string") query._env = route.query._env;
  router.push({ path: "/token-detail", query });
};

const invokeShelfApp = () => {
  invokeAppByYYB({
    targetPath: "shelf/detail",
    params: { shelfId: shelfId.value },
  });
};

const onClickLeft = () => {
  if (window.history.length > 1) router.back();
  else router.push("/");
};

const configName = (key: string, value?: string) => {
  if (!value) return "";
  const list = publishConfig.value?.[key] || [];
  return list.find((item) => item.id === value)?.name || value;
};

const loadPublishConfig = async () => {
  try {
    const response =
      (await NftApi.getSpPublishConfig()) as PublishConfigResponse;
    publishConfig.value = response?.data?.publishConfig || {};
  } catch (error) {
    console.error("Failed to load commission config", error);
  }
};

const loadShelf = async () => {
  const value =
    typeof route.query.shelfId === "string" ? route.query.shelfId : "";
  shelfId.value = value;
  simpleInfo.value = {};
  detailInfo.value = {};
  errorMessage.value = "";

  if (!value) {
    loading.value = false;
    errorMessage.value = "橱窗不存在或已删除";
    return;
  }

  loading.value = true;
  try {
    const [simpleResponse, detailResponse] = (await Promise.all([
      ShelfApi.getSimpleInfo(value),
      ShelfApi.getDetail(value),
    ])) as [ApiResponse<ShelfSimpleInfo>, ApiResponse<ShelfDetailInfo>];
    if (
      String(simpleResponse?.code) !== "0" ||
      String(detailResponse?.code) !== "0"
    ) {
      throw new Error(
        simpleResponse?.message || detailResponse?.message || "Shelf not found"
      );
    }
    simpleInfo.value = simpleResponse.data || {};
    detailInfo.value = detailResponse.data || {};
  } catch (error) {
    console.error("Failed to load shelf detail", error);
    errorMessage.value = "橱窗不存在或已删除";
  } finally {
    loading.value = false;
  }
};

watch(
  () => route.query.shelfId,
  () => loadShelf()
);

onMounted(() => {
  loadShelf();
  loadPublishConfig();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VanSticky), null, {
      default: _withCtx(() => [
        _createVNode(_unref(VanNavBar), {
          "left-arrow": "",
          title: "橱窗详情",
          onClickLeft: onClickLeft
        })
      ]),
      _: 1
    }),
    _createVNode(DownloadBanner, { onOnInvokeApp: invokeShelfApp }),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(VanLoading), {
            color: "#7247dc",
            size: "32px"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(errorMessage.value), 1),
            _hoisted_6
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("main", _hoisted_7, [
              (_unref(attachments).length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachments), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${item.url}-${index}`,
                        class: "shelf-cover",
                        onClick: ($event: any) => (previewImage(index))
                      }, [
                        _createElementVNode("img", {
                          class: "shelf-cover-image",
                          src: appendImageStyle(item.url),
                          alt: simpleInfo.value.name
                        }, null, 8, _hoisted_10),
                        (item.relatedType === 'TOKEN' && item.relatedId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "shelf-token-entry",
                              type: "button",
                              onClick: _withModifiers(($event: any) => (toTokenPage(item.relatedId)), ["stop"])
                            }, _hoisted_14, 8, _hoisted_11))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_9))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_15, [
                _createElementVNode("h1", _hoisted_16, _toDisplayString(simpleInfo.value.name), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(displayPrice)), 1),
                    (_unref(priceSuffix))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(priceSuffix)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    (detailInfo.value.showAvailableInventory)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, " 库存 " + _toDisplayString(_unref(totalStock)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, "卖出 " + _toDisplayString(detailInfo.value.stats?.soldAmount || 0), 1),
                    _createElementVNode("span", null, "收藏 " + _toDisplayString(detailInfo.value.stats?.favoriteCount || 0), 1)
                  ])
                ]),
                (simpleInfo.value.description)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(simpleInfo.value.description), 1))
                  : _createCommentVNode("", true)
              ]),
              (_unref(hasDeliveryInfo))
                ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      (_unref(deadlineText))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("strong", null, _toDisplayString(_unref(deadlineText)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(commission).scopeOfAuthorization)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _hoisted_31,
                            _createElementVNode("strong", null, _toDisplayString(configName(
                  "authorizationScopes",
                  _unref(commission).scopeOfAuthorization
                )), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(commission).publishPermission)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("strong", null, _toDisplayString(configName("permissions", _unref(commission).publishPermission)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(commission).deliveryFormat)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _hoisted_35,
                            _createElementVNode("strong", null, _toDisplayString(configName("formats", _unref(commission).deliveryFormat)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_36,
              _createVNode(CommentList, {
                "collection-data": {},
                "token-id": shelfId.value,
                "product-type": "COMMISSION",
                "origin-trade-type": "SHELF",
                type: "shelf"
              }, null, 8, ["token-id"])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, " ¥" + _toDisplayString(_unref(displayPrice)) + _toDisplayString(_unref(priceSuffix)), 1),
                (detailInfo.value.showAvailableInventory)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, " 库存 " + _toDisplayString(_unref(totalStock)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(MainButton, {
                text: _unref(actionText),
                disabled: _unref(actionDisabled),
                inactivated: _unref(isOwner),
                onOnInvokeApp: invokeShelfApp
              }, null, 8, ["text", "disabled", "inactivated"])
            ])
          ], 64))
  ]))
}
}

})